import { styled } from 'styled-components'

export const CustomValue = styled.small`
  font-size: ${(props) => props.theme.typography.body_size.normal};
  font-weight: 500;
`
